import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  "aria-hidden": "true",
  width: "15px",
  height: "15px",
  "data-v-777b7522": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("use", {
      "xlink:href": "#icon-twoyellow-red",
      "data-v-777b7522": ""
    }, null, -1)
  ])))
}